import React from "react";
import { useTranslation, Trans } from 'react-i18next';
import GridContainer from "components/grid/gridContainer.js";
import GridItem from "components/grid/gridItem.js";
// @material-ui/core components
import ConsoleIcon from 'components/icons/consoleIcon';
import { makeStyles } from "@material-ui/core";

const styles = {
    title: {
        paddingBottom: "20px"
    },
    textConsoles: {
        'text-align': "left"
    }
};
const useStyles = makeStyles(styles);

export default function SupportedConsolesSection(props) {
    const classes = useStyles();
    const { ...rest } = props;
    useTranslation();

    return (
        <div {...rest}>
            <GridContainer>
                <GridItem xs={12} sm={12} md={12} className={classes.title + " step1-guidedTour"}>
                    <h3 className={classes.textConsoles}>
                        <strong><Trans i18nKey="supportedTitle" /></strong>
                    </h3>
                    <div className={classes.textConsoles}>
                        <Trans i18nKey="supportedMessage" />
                    </div>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                    <ConsoleIcon consoleType='Discover SE3 HD' bigIcon={true} showText={true} />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                    <ConsoleIcon consoleType='Discover SE3' bigIcon={true} showText={true} />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                    <ConsoleIcon consoleType='ST' bigIcon={true} showText={true} />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                    <ConsoleIcon consoleType='70T' bigIcon={true} showText={true} />
                </GridItem>
            </GridContainer>
        </div >
    );
}